import { PilgrimSchema } from '../types/pilgrim';

export const validatePilgrimData = (data: any): { isValid: boolean; errors: string[] } => {
  const errors: string[] = [];

  // Helper functions
  const isValidDate = (dateStr: string) => {
    const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/(19|20)\d\d$/;
    return regex.test(dateStr);
  };

  const isValidEmail = (email: string) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  // Serial Number validation
  if (!data.Serial_Number) {
    errors.push('رقم الحاج مطلوب');
  } else if (!/^\d+$/.test(data.Serial_Number)) {
    errors.push('رقم الحاج يجب أن يكون رقماً');
  }

  // Required fields validation
  const requiredFields = [
    'Name',
    'Passport_Number',
    'pilgrim_category',
    'package_nickName',
    'Gender',
    'Date_of_Birth'
  ];

  for (const field of requiredFields) {
    if (!data[field]) {
      errors.push(`الحقل ${field} مطلوب`);
    }
  }

  // Type-specific validations
  if (data.Gender && !['male', 'female'].includes(data.Gender)) {
    errors.push('الجنس يجب أن يكون ذكر أو أنثى');
  }

  if (data.Date_of_Birth && !isValidDate(data.Date_of_Birth)) {
    errors.push('صيغة التاريخ يجب أن تكون dd/mm/yyyy');
  }

  // Validate pilgrim category
  if (data.pilgrim_category && !['B2C', 'B2G'].includes(data.pilgrim_category)) {
    errors.push('فئة الحاج يجب أن تكون B2C أو B2G');
  }

  if (data.Email && !isValidEmail(data.Email)) {
    errors.push('البريد الإلكتروني غير صالح');
  }

  const roomTypes = ['double', 'triple', 'quadruple'];
  if (data.main_makkah_roomType && !roomTypes.includes(data.main_makkah_roomType)) {
    errors.push('نوع غرفة مكة الرئيسية غير صالح');
  }

  if (data.shifting_makkah_roomType && !roomTypes.includes(data.shifting_makkah_roomType)) {
    errors.push('نوع غرفة مكة الثانوية غير صالح');
  }

  if (data.madinah_roomType && !roomTypes.includes(data.madinah_roomType)) {
    errors.push('نوع غرفة المدينة غير صالح');
  }

  return {
    isValid: errors.length === 0,
    errors
  };
};

export const generateExcelTemplate = (): PilgrimSchema => {
  return {
    id: '2420', // Same as Serial_Number
    Serial_Number: '2420',
    pilgrim_category: 'B2C',
    package_nickName: 'ithraa alkhair 01',
    Passport_Number: '532867136',
    Name: 'Nazia Aktar Sharmin',
    Flight_Contract_Type: 'B2B',
    PNR_NO: 'SLTLDE',
    flight_Ticket: '34456743',
    Date_of_Birth: '12/03/1996',
    Pilgrim_Type: 'Main',
    nusuk_group: '2195',
    Gender: 'female',
    Mobile_Number: '+447471506267',
    Email: 'NAZIA_XO@YAHOO.CO.UK',
    Residence_Country: 'United Kingdom',
    Nationality_Country: 'United Kingdom',
    main_makkah_roomType: 'quadruple',
    shifting_makkah_roomType: 'triple',
    madinah_roomType: 'double'
  };
};